import { FetchAPI, ParamsSerializer } from './auth-service';

const fields = [
  {
    variable: "name",
    title: "Instance Group Name",
    hidden: false,
    type: "string",
    field: "name",
  },
  {
    variable: "instances",
    title: "Instances",
    hidden: false,
    type: "number",
    field: "size",
  },
  {
    variable: "creationTimestamp",
    title: "Created At",
    hidden: false,
    type: "string",
    field: "creationTimestamp",
  },
  {
    variable: "zone",
    title: "Zone",
    hidden: false,
    type: "string",
    field: "zone",
  },
];

const NETWORK_TYPE = [
  { value: 'network in this project', name: 'Network in this project' },
  { value: 'network shared with me', name: 'Network shared with me ' },

]

class InstanceGroupDataService {
  constructor() {

    if (!InstanceGroupDataService.instance) {
      InstanceGroupDataService.instance = this;
    }
    this.searchPlaceholder = 'Search Instance Group';
    this.fields = fields;

    this.getInstanceGroup = () => {
      return FetchAPI({
        url: `system/gcp/instance-groups/aggregate`,
        method: 'GET',
      });
    };

    this.getInstancesbyInstanceGroup = (zone, group) => {
      return FetchAPI({
        url: `system/gcp/instance-groups/${zone}/${group}`,
        method: 'GET'
      });
    }

    this.getInstanceGroups = () => {
      return FetchAPI({
        url: `system/gcp/aggregated/instance-groups`,
        method: 'GET',
      });
    };

    this.deleteInstanceGroup = (zone, group) => {
      return FetchAPI({
        url: `system/gcp/instance-groups/${zone}/${group}`,
        method: 'DELETE'
      });
    }

    this.createInstanceGroup = (zone, body) => {
      return FetchAPI({
        url: `system/gcp/instance-groups/${zone}`,
        method: 'POST',
        body: body
      });
    }

    this.addInstances = (zone, group, body) => {
      return FetchAPI({
        url: `system/gcp/instance-groups/${zone}/${group}/-add`,
        method: 'POST',
        body: body
      });
    }

    this.removeInstances = (zone, group, body) => {
      return FetchAPI({
        url: `system/gcp/instance-groups/${zone}/${group}/-remove`,
        method: 'POST',
        body: body
      });
    }

    return InstanceGroupDataService.instance;
  }
}

const InstanceGroupService = new InstanceGroupDataService();

export {
  InstanceGroupService as default,
  fields as InstanceGroupFields,
  NETWORK_TYPE,
};
